import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompanyPage } from './company.page';

const routes: Routes = [
	{
		path: '',
		component: CompanyPage,
	},
	{
		path: 'epp-signups',
		loadChildren: () =>
			import('./epp-signups/epp-signups.module').then(
				m => m.EppSignupsPageModule,
			),
	},
	{
		path: 'update-info',
		loadChildren: () =>
			import('./update-info/update-info.module').then(
				m => m.UpdateInfoPageModule,
			),
	},
	{
		path: 'manage-email',
		loadChildren: () =>
			import('./manage-email/manage-email.module').then(
				m => m.ManageEmailPageModule,
			),
	},
	{
		path: 'b2b',
		loadChildren: () => import('./b2b/b2b.module').then(m => m.B2bPageModule),
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class CompanyPageRoutingModule {}
